/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5DanteV1DeadMessageState } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_DANTE_V1_DEAD_MESSAGE_STATE_ENTITY_NAME = 'o5.dante.v1.DeadMessage';
export const o5DanteV1DeadMessageStateEntity = new schema.Entity<O5DanteV1DeadMessageState>(O5_DANTE_V1_DEAD_MESSAGE_STATE_ENTITY_NAME, {}, { idAttribute: 'messageId' });

